import fetch from "auth/FetchInterceptor";
import { env } from "configs/EnvironmentConfig";

const AuthService = {};

const API_BASE_URL = env.API_ENDPOINT_URL;
const cntrlName = "user/";

AuthService.login = function (data) {
  const { emailaddress, password } = data;
  return fetch({
    url: `${API_BASE_URL + cntrlName}login?emailaddress=${encodeURIComponent(
      emailaddress
    )}&password=${encodeURIComponent(password)}`,
    method: "get",
    data: data,
  });
};

AuthService.loginUsingStudentid = function (data) {
  console.log(data);
  const { emailaddress, password } = data;
  return fetch({
    url: `${API_BASE_URL + cntrlName}Student/login?Studentid=${data?.Studentid}&password=${encodeURIComponent(password)}`,
    method: "get",
    data: data,
  });
};


AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

export default AuthService;
